module.exports = __webpack_public_path__ + "img/female-youngadult-foot.bc9f0277.svg";